interface CostumerListItem {
  id: string;
  name: string;
}

export const findCostumerById = <T extends CostumerListItem>(costumers: T[], id: string) => {
  if (!id) return costumers[0];

  const res = costumers.find((item) => item.id === id);
  if (!res) return costumers[0];

  return res;
};
